import Button from '@mui/material/Button';
import { memo, ReactElement, useCallback, useMemo } from 'react';
import { FilterDTO } from '../../api';
import { useTranslation } from 'react-i18next';

export interface ResetFiltersButtonProps {
  filter: FilterDTO;
  onFilterChange: (filter: FilterDTO) => void;
}

export const ResetFiltersButton = memo(function ({ filter, onFilterChange }: ResetFiltersButtonProps): ReactElement {
  const { t } = useTranslation();

  const isDisabled = useMemo(() => !Object.keys(filter).length, [filter]);

  const handleClick = useCallback(() => {
    onFilterChange({});
  }, [onFilterChange]);

  return (
    <Button
      variant='contained'
      onClick={handleClick}
      disabled={isDisabled}
      sx={{ borderRadius: '0.5rem' }}
      disableElevation
    >
      {t(`filter.deleteAll`)}
    </Button>
  );
});
